module.exports = __webpack_public_path__ + "static/media/reno-placeholder.8adca47b.webp";